// Generated types for SysMLExpression
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from './sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from './sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLExpressionReadAPI extends SysMLElementReadAPI {
  /** formula for edge 'aliases': 'width * height' */
  spec: string;
  last_error?: string | null;
}

export interface SysMLExpressionWriteAPI extends SysMLElementWriteAPI {
  /** formula for edge 'aliases': 'width * height' */
  spec: string;
  last_error?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLExpressionReadAPISchema: z.ZodType<SysMLExpressionReadAPI> = SysMLElementReadAPISchemaObject.extend({
  spec: z.string(),
  last_error: z.string().nullable().optional(),
}).passthrough();

export const SysMLExpressionWriteAPISchema: z.ZodType<SysMLExpressionWriteAPI> = SysMLElementWriteAPISchemaObject.extend({
  spec: z.string(),
  last_error: z.string().nullable().optional(),
}).passthrough();
